import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { resourceclosings_returndata } from 'src/types/resourceclosings_returndata'; 
import { resourcereductions_returndata } from 'src/types/resourcereductions_returndata';
import { bmxurl, getAccess } from 'src/globals';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';

@Component({
  selector: 'app-resourceclosings',
  templateUrl: './resourceclosings.component.html',
  styleUrls: ['./resourceclosings.component.css']
})
export class ResourceclosingsComponent implements OnInit {
  ListResourceClosings: any;
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateUpdateResponse: any;
  resourceClosing: any;
  DisabledresourceClosing: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any[] = [];

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  httpResponse: any;

  ListResourceReductions: any;
  isReductionDisabled: boolean = true;
  selectedReductionItems: any[] = [];

  //0 = Resource Closings, 1 = Resource Reductions.
  activeTabIndex: number = 0;

  allClosingsSelected: boolean = false;
  allReductionsSelected: boolean = false;

  constructor(
    private http: HttpClient, private appComp: AppComponent, private router: Router, private route: ActivatedRoute, private messageService: MessageService, private globalService: GlobalService) { 

      
    }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    //The reduction edit screen returns with ?tab=reductions, so saving or cancelling lands
    //back on the tab it was opened from rather than on Resource Closings.
    if(this.route.snapshot.queryParamMap.get('tab') == 'reductions')
      this.activeTabIndex = 1;

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("RESOURCECLOSINGS", user)){
          this.AccessAllowed = true;
          this.loadgrid(false);
          this.loadReductionGrid(false);
        }

        this.CompletedLoading = true;
        
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });


  }

  toggleDisabled(){
    this.loadgrid(!this.isDisabled);
  }

  disableData(resourceClosingID)
  {
    this.http.delete(bmxurl + "ResourceClosing/" + this.VenueID + "/" + resourceClosingID).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Disabled', detail:'Resource Closing successfully disabled'});

        this.loadgrid(false);
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Resource Closing'});
    })
  }
  

  loadgrid(showdisabled: boolean)
  {
    this.http.get(bmxurl + "ResourceClosingList/" + this.VenueID + "/" + "/" + showdisabled).subscribe(response => {
      this.ListResourceClosings = (response as resourceclosings_returndata);

      if ((response as resourceclosings_returndata).messages.length > 0)
        {
          (response as resourceclosings_returndata).messages.forEach(error => {
            this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
          });
        }
    }, error => {
    });
  }

  editData(EditData)
  {
    let resourceClosingID = EditData;
    this.router.navigateByUrl("/resourceclosingsedit/" + resourceClosingID);
  }

  disableMulti()
  {
    if(this.selectedItems == null || this.selectedItems.length == 0)
      return;

    this.selectedItems.forEach(element => {
      this.http.delete(bmxurl + "ResourceClosing/" + this.VenueID + "/" + element).subscribe(response => {
        this.CreateUpdateResponse = response
        if(this.CreateUpdateResponse.succeeded)
        {
          this.loadgrid(false);
        }
      }, error => {
      })
    });

    this.selectedItems = [];
    this.allClosingsSelected = false;
  }

  toggleReductionDisabled(){
    this.loadReductionGrid(!this.isReductionDisabled);
  }

  //Error handler left silent to match loadgrid - until the ResourceReduction API is
  //deployed this call fails on every visit, and a toast would fire on the Closings tab too.
  loadReductionGrid(showdisabled: boolean)
  {
    this.http.get(bmxurl + "ResourceReductionList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
      this.ListResourceReductions = (response as resourcereductions_returndata);

      if ((response as resourcereductions_returndata).messages.length > 0)
        {
          (response as resourcereductions_returndata).messages.forEach(error => {
            this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
          });
        }
    }, error => {
    });
  }

  editReduction(resourceReductionID)
  {
    this.router.navigateByUrl("/resourcereductionsedit/" + resourceReductionID);
  }

  disableReduction(resourceReductionID)
  {
    this.http.delete(bmxurl + "ResourceReduction/" + this.VenueID + "/" + resourceReductionID).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Disabled', detail:'Resource Adjustment successfully disabled'});
        this.loadReductionGrid(false);
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Resource Adjustment'});
    })
  }

  disableMultiReductions()
  {
    if(this.selectedReductionItems == null || this.selectedReductionItems.length == 0)
      return;

    this.selectedReductionItems.forEach(element => {
      this.http.delete(bmxurl + "ResourceReduction/" + this.VenueID + "/" + element).subscribe(response => {
        this.CreateUpdateResponse = response
        if(this.CreateUpdateResponse.succeeded)
        {
          this.loadReductionGrid(false);
        }
      }, error => {
      })
    });

    this.selectedReductionItems = [];
    this.allReductionsSelected = false;
  }

  //Header checkboxes: tick or clear every row in the list.
  toggleAllClosings(checked: boolean) {
    this.selectedItems = checked ? (this.ListResourceClosings?.data ?? []).map(c => c.resourceclosingid) : [];
  }

  toggleAllReductions(checked: boolean) {
    this.selectedReductionItems = checked ? (this.ListResourceReductions?.data ?? []).map(r => r.resourcereductionid) : [];
  }
  
  }